import { useEffect } from "react";
import { Typography, Button } from "../../components"
import "./styles.css";

export default function GidsRedirect() {
  useEffect(() => {
  window.location.replace("https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl/checkout/gratis-gids-voor-professionals-de-nieuwe-standaard-in-borstvoedingszorg/s/cfgids");
  }, []);

    return (
            <div className='container'>
                <Typography type='h2' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Je wordt doorgestuurd<br />naar de downloadpagina...</Typography>
                <div className="button-container">
                    <Button 
                        target='_blank' 
                        href={"https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl/checkout/gratis-gids-voor-professionals-de-nieuwe-standaard-in-borstvoedingszorg/s/cfgids"} 
                        text={`Zo niet, klik dan hier.`}
                    />
                </div>
            </div>
        )
    }